$(document).ready(function(){
  var options = {
  autoplay: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1
  }
  setTimeout(function(){

  $('.annouce-bar-slider').slick({
    autoplay: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1
  });
    $('.announcement-bar__message').css("width:100%");
  },1000);
  
  setInterval(function(){
  $('.annouce-bar-slider').on('lazyLoaded', function(event, slick, image, imageSource) {
  slick.resize() });
  }, 1000);

});

